module.exports = __webpack_public_path__ + "img/37.fc08e1fb.png";